import { View } from "@react-pdf/renderer";
import { ResumePDFSkillsTwoColumn } from "components/Resume/ResumePDF/common";
import { TemplateFourResumeSection } from "./common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeSkills } from "lib/redux/types";

export const Skills = ({
  heading,
  skills,
  themeColor,
}: {
  heading: string;
  skills: ResumeSkills;
  themeColor: string;
}) => {
  const { descriptions } = skills;

  return (
    <TemplateFourResumeSection themeColor={themeColor} heading={heading}>
      <View wrap={false} style={{ ...styles.flexRow }}>
        <ResumePDFSkillsTwoColumn items={descriptions} />
      </View>
    </TemplateFourResumeSection>
  );
};
